import React, { forwardRef } from 'react'

import ImageBox, { ImageProps } from 'uiComponents/atoms/ImageBox/ImageBox'
import { StyledProductImage } from './StyledProductImage'

export interface IProductImageProps extends ImageProps {
  dataTestId?: string
  padded?: boolean
  hoverEffect?: boolean
  className?: string
  reducedPaddingTop?: boolean
  as?: 'button'
}

const ProductImage = forwardRef<
  HTMLDivElement | HTMLButtonElement,
  IProductImageProps
>(function ProductImage(
  {
    dataTestId,
    src,
    srcSet,
    sizes,
    importance,
    loading,
    alt,
    onLoad,
    children,
    as,
    ...props
  },
  ref,
) {
  return (
    <StyledProductImage
      {...props}
      as={as}
      ref={ref as any}
      data-testid={dataTestId || 'ProductImage'}
    >
      <ImageBox
        src={src}
        srcSet={srcSet}
        sizes={sizes}
        importance={importance}
        onLoad={onLoad}
        alt={alt}
        loading={loading || 'lazy'}
        data-testid={dataTestId ? `${dataTestId}View` : 'ProductImageView'}
      />
      {children}
    </StyledProductImage>
  )
})

export default ProductImage
